import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=28420e87&scoped=true&"
import script from "./Data.vue?vue&type=script&lang=js&"
export * from "./Data.vue?vue&type=script&lang=js&"
import style0 from "./Data.vue?vue&type=style&index=0&id=28420e87&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28420e87",
  null
  
)

export default component.exports